import TtamDeliveryTypeCboInfo from './cbo-info/index.vue';
import TtamDeliveryTypeLabel from './label/index.vue';
import TtamDeliveryTypeLabelHint from './label-hint/index.vue';
import TtamDeliveryTypeOptions from './options/index.vue';
import TtamDeliveryTypePlainOption from './plain/index.vue';
import * as hooks from './hooks';

export default {
  TtamDeliveryTypeCboInfo,
  TtamDeliveryTypeLabelHint,
  TtamDeliveryTypeLabel,
  TtamDeliveryTypeOptions,
  TtamDeliveryTypePlainOption,
  ...hooks,
};
